/**
 * Enregistrement du Service Worker — module 8.A.3
 * (ex `public/js/core/sw-register.js`, externalisé du HTML en 6.0.6c-1 pour
 * la CSP sans inline).
 */
export function registerServiceWorker(): void {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker
      .register('/sw.js')
      .catch((err) => console.warn('SW registration failed:', err));
  }
}
